export default __webpack_public_path__ + "static/media/logo3_orange.bfcc6b24.svg";